import { ref } from 'vue';

export default function useModal(initialValue) {
  const modal = ref(initialValue);
  const closeModal = () => (modal.value = false);
  const openModal = () => (modal.value = true);
  const toggleModal = () => (modal.value = !modal.value);
  return { modal, closeModal, openModal, toggleModal };
}
